module.exports = __webpack_public_path__ + "static/CircularStd-BlackItalic-9470b32b17ef5497e09a761d32307fd4.woff2";